import { render, staticRenderFns } from "./index-modal.vue?vue&type=template&id=1a351f8c&scoped=true&"
import script from "./index-modal.vue?vue&type=script&lang=js&"
export * from "./index-modal.vue?vue&type=script&lang=js&"
import style0 from "./index-modal.vue?vue&type=style&index=0&id=1a351f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a351f8c",
  null
  
)

export default component.exports